import React from 'react';

import { BaseOrderView } from 'views/BaseOrderView';

import {
  SqCustomerPaidReceipts,
  SqLayout,
  SqPaymentCard,
  SqPaymentDetails,
  SqPaymentLoading,
  SqPaymentRedirect,
  SqPaymentRulesView,
  SqPaymentStatus,
} from './components';

export const SqOrderView: React.FC = () => (
  <BaseOrderView
    overrideComponents={{
      Layout: SqLayout,
      PaymentStatus: SqPaymentStatus,
      PaymentDetails: SqPaymentDetails,
      PaymentRules: SqPaymentRulesView,
      PaymentLoading: SqPaymentLoading,
      CustomerPaidReceipts: SqCustomerPaidReceipts,
      PaymentCard: SqPaymentCard,
      EcomRedirect: SqPaymentRedirect,
      ProviderPaymentRedirect: SqPaymentRedirect,
    }}
  />
);
